import React from 'react';
import { FilterForm, useFilterFormActions } from './filter-form';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';

export const BooleanFilters = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems} />
);

function BooleanFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );
  return (
    <>
      <FormControlLabel
        value="True"
        control={<Radio />}
        label="True"
        name="$eq"
        inputRef={form.register}
        />
      <FormControlLabel
        value="False"
        control={<Radio />}
        label="False"
        name="$eq"
        inputRef={form.register}
      />
    </>
  );
}

export const BooleanFiltersLowerCase = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItemsLowerCase} />
);

function BooleanFilterFormItemsLowerCase({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );
  return (
    <>
    <FormControlLabel
        value="false"
        control={<Radio />}
        label="Yes"
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="No"
        name="$empty"
        inputRef={form.register}
        />
    </>
  );
}

export const BooleanFiltersYesNo = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItemsYesNo} />
);

function BooleanFilterFormItemsYesNo({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );
  return (
    <>
      <FormControlLabel
        value="Yes"
        control={<Radio />}
        label="Yes"
        name="$eq"
        inputRef={form.register}
        />
      <FormControlLabel
        value="No"
        control={<Radio />}
        label="No"
        name="$eq"
        inputRef={form.register}
      />
    </>
  );
}


export const BooleanFiltersActiveInactive = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItemsActiveInactive} />
);

export const BooleanFiltersDoNotSell = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItemsDoNotSell} />
);

function BooleanFilterFormItemsDoNotSell({ setRadioFilter, radioValue, column }) {
  const { form } = useFilterFormActions(radioValue, setRadioFilter);
  return (
    <>
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="Yes"
        name="$eq"
        inputRef={form.register}
      />
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="No"
        name="$eq"
        inputRef={form.register}
      />
    </>
  );
}

function BooleanFilterFormItemsActiveInactive({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );
  return (
    <>
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="Inactive"
        name="$eq"
        inputRef={form.register}
        />
      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Active"
        name="$eq"
        inputRef={form.register}
      />
    </>
  );
}
